import * as React from 'react';
import {
    Stack,
    Typography,
} from '@mui/material';
import {
    TextInput,
    required,
    SelectInput,
} from 'react-admin';
import { projectDocumentTypeSelector, projectDocumentExtensionSelector } from '@/root/defaultConfiguration';

export const ProjectFileConfigInputs = () => {
    return (
        <Stack flex={1}>
            <ProjectFileConfigBasicInputs />
        </Stack>
    );
};

const ProjectFileConfigBasicInputs = () => {
    return (
        <Stack>
            <Typography variant="h6">Basic Info</Typography>
            <TextInput source="title" validate={required()} fullWidth />
            <TextInput source="short_name" validate={required()} fullWidth />
            <TextInput source="template_path" validate={required()} fullWidth />
            {/* <TextInput source="folder_destination" validate={required()} fullWidth /> */}
            <SelectInput
                source="file_extension"
                label="File Extension"
                helperText={false}
                optionText={choice => choice.label}
                optionValue={'value'}
                choices={projectDocumentExtensionSelector}
            />
            <SelectInput
                source="project_file_type"
                label="Project File Type"
                helperText={false}
                optionText={choice => choice.label}
                optionValue={'value'}
                choices={projectDocumentTypeSelector}
            />
            <TextInput
                source="data_config"
                validate={[required()]}
                multiline
                parse={v => JSON.parse(v)}
                format={v => JSON.stringify(v)} />
        </Stack>
    );
};
